// import { PlusSVG } from '@common_components/svg/plus.svg';
// import { RecurrenceSVG } from '@common_components/svg/recurrence.svg';
import { dayjs } from '@umanforge/common';
import { TimeGrid } from 'interfaces/timegrid.interface';
import { TimeGridRecurrenceItem } from 'interfaces/timegridRecurrence.interface';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';

interface TimegridCalendarTileProps {
  timegridRecurrence: TimeGridRecurrenceItem;
  timeGrid: TimeGrid;
  className?: string;
  onClick: ( timeGridRecurrence: TimeGridRecurrenceItem ) => void
}

export const TimegridCalendarTile: React.FC<TimegridCalendarTileProps> = ( { timegridRecurrence, className, timeGrid, onClick } ) => {
  const { t } = useTranslation();

  const { colStart, colEnd } = useMemo( () => {
    let value = dayjs( timegridRecurrence?.date ).day() as number;
    if ( value == 0 ) { value = 7; }
    return {
      colStart: value,
      colEnd: value + 1
    };
  }, [ timegridRecurrence ] );

  return <div
    className={'h-fit w-full group cursor-pointer'}
    style={{ gridColumnStart: colStart, gridColumnEnd: colEnd }}
    onClick={ () => { onClick( timegridRecurrence ); } }
  >
    <div id={ 'timegrid_tile' + timegridRecurrence?.id } className={ 'relative bg-white border border-gray-200 rounded-md shadow-md font-texte p-1 text-sm text-gray-600 my-1 place-self-center w-fit flex items-center justify-center ' + className }>
      <p className='text-center truncate'>{ timeGrid?.name ?? '' }</p>
      { ( timeGrid?.disabled ) ?
        <p className='border rounded text-xs text-gray-500 h-fit w-fit px-0.5 ml-0.5'>{ t( 'translation:old' ) }</p>
        : <></>
      }
    </div>
    <Tooltip
      anchorSelect={ '#timegrid_tile' + timegridRecurrence?.id }
      className='z-[1000] max-w-[600px] text-wrap border border-gray-200'
      place="top"
      positionStrategy='fixed'
      variant='light'
    >
      <div className='text-gray-800 max-w-64'>
        <div className='w-full truncate'>
          <span className='text-[14px] font-semibold'> { timeGrid?.name ?? '' } </span>
          <p className='pl-2 pt-1'> { dayjs( timeGrid?.timeStart ).format( 'LT' ) + ' - ' + dayjs( timeGrid?.timeEnd ).format( 'LT' ) } </p>
        </div>
        { ( timeGrid?.breaktimes && timeGrid?.breaktimes.length > 0 ) &&
          <div className='flex flex-wrap'>
            <p className='pl-2 w-max mr-3'> { t( 'translation:breaktimes' ) + ': ' } </p>
            <div className='flex flex-wrap gap-1 items-center justify-center w-full'>
              {
                timeGrid?.breaktimes.map( breaktime =>  {
                  return <p className='text-xs p-0.5 h-fit w-fit border border-gray-300 rounded' key={ breaktime.id }>{ dayjs( breaktime.timeStart ).format( 'LT' ) + ' - ' + dayjs( breaktime.timeEnd ).format( 'LT' ) }</p>;
                } )
              }
            </div>
          </div>
        }
        {/* { timeGrid?.disabled ?
          <p className='pl-2 pt-1'> { t( 'translation:the_timegrid_is_not_used' ) } </p>
          : <></>
        } */}
      </div>
    </Tooltip>
  </div>;
};
